module.exports = __webpack_public_path__ + "static/media/accessibility.2b99ee91.svg";